import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { withGenericConfig } from "/contexts/generic-config-context";
import { MAIN_ID, FOOTER_ID } from "constants/element-ids";
import { StyledBypassBlocksMenuComponent } from "./bypass-block-menu.scss";
const BypassBlocksMenuComponent = (props)=>{
    const [hasFooter, setHasFooter] = useState(false);
    useEffect(()=>{
        const footer = document.querySelector(FOOTER_ID);
        setHasFooter(!!footer);
    });
    return /*#__PURE__*/ _jsxs(StyledBypassBlocksMenuComponent, {
        className: "bypass-block-menu-component",
        "aria-label": "Accessibility Menu",
        children: [
            /*#__PURE__*/ _jsx("a", {
                href: `#${MAIN_ID}`,
                className: "menu-item",
                children: props.translate("accessibility.blocksMenu.skipToMain")
            }),
            hasFooter && /*#__PURE__*/ _jsx("a", {
                href: `#${FOOTER_ID}`,
                className: "menu-item",
                children: props.translate("accessibility.blocksMenu.skipToFooter")
            })
        ]
    });
};
export default withGenericConfig(BypassBlocksMenuComponent);
